import Sommaire from "./MajList.json";
import { useEffect, useState } from "react";
import './Maj.css';

import React, { useContext } from 'react';
import { SharedVariableContext } from '../../App';


export default function Majlist() {
// État pour stocker les données JSON
const [majList, setMajList] = useState([]);

const { MajTypeDePage, MajIllustration } = useContext(SharedVariableContext);
// Mettre à jour la variable partagée
useEffect(() => {
        MajTypeDePage('Nouveautés');
        MajIllustration('Nouveautés');
      }, [MajTypeDePage, MajIllustration]);

useEffect(() => {
    // Charger les données JSON dans l'état
    setMajList(Sommaire);
    }, []); // Tableau de dépendances vide pour exécuter une seule fois au montage

  // Mapping des types vers des classes CSS supplémentaires pour MajType
const typeClassMap = {
    Nouveau: "MajTypeNouveau",
    Modification: "MajTypeModification",
    Default: "MajTypeDefault",
    };

return (
    <div id="Maj">
        <h1>Mises à jour</h1>
        <div className="MajList">
            {majList.map((item, index) => (
            <div className="Maj" key={index}>
                <div className="MajDate">{item.date}</div>
                <div className={`MajType ${typeClassMap[item.type] || typeClassMap.Default}`}>{item.type}</div>
                <div className="MajSection">{item.section}</div>
                <div className="MajTitre">{item.titre}</div>
            </div>
            ))}
        </div>
    </div>
    );
}
